import { render, staticRenderFns } from "./StandardModal.vue?vue&type=template&id=319ab91a&scoped=true"
import script from "./StandardModal.vue?vue&type=script&lang=ts"
export * from "./StandardModal.vue?vue&type=script&lang=ts"
import style0 from "./StandardModal.vue?vue&type=style&index=0&id=319ab91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ab91a",
  null
  
)

export default component.exports